import { render, staticRenderFns } from "./SchedulePlaceholders.vue?vue&type=template&id=00e849d1&scoped=true"
import script from "./SchedulePlaceholders.vue?vue&type=script&lang=js"
export * from "./SchedulePlaceholders.vue?vue&type=script&lang=js"
import style0 from "./SchedulePlaceholders.vue?vue&type=style&index=0&id=00e849d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e849d1",
  null
  
)

export default component.exports